module.exports = __webpack_public_path__ + "img/IMG_9512_L_Wood.0aac8e03.jpg";